var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBookOpen = function SvgBookOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 3a9 9 0 0 0-8 4.88A9 9 0 0 0 16 3H0v33l.07 1h16c6.81 0 6.93 6.72 6.93 7h2c0-.29.12-7 7-7h16V3H32Zm14 32H32a8.38 8.38 0 0 0-7 3.13V12h-2v26.11A8.3 8.3 0 0 0 16.07 35H2V5h14a6.92 6.92 0 0 1 7 7h2a6.92 6.92 0 0 1 7-7h14v30Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m27.64 43.07 1.81.86A5.14 5.14 0 0 1 34.07 41H48v-2H34.07a7.15 7.15 0 0 0-6.43 4.07ZM14 39H0v2h14a5.14 5.14 0 0 1 4.62 2.93l1.81-.86A7.15 7.15 0 0 0 14 39Z"
  })));
};
export default SvgBookOpen;